/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable space-before-function-paren */

declare global {
  interface Array<T> {
    diff(arr: any): Array<T>;
    unique(): Array<T>;
  }
  interface String {
    toFirstUppercase(): String;
    toCPF(): String;
    toCNPJ(): String;
    toCEP(): String;
    toFone(): String;
    toRemovePontuacao(): String;
  }  
}

export default class CustomPrototype {

  public static register() {

    // Difference between two arrays
    // Ref: https://stackoverflow.com/questions/1187518/how-to-get-the-difference-between-two-arrays-in-javascript
    if (!Array.prototype.diff) {
      Array.prototype.diff = function (a: any) {
        return this.filter(function (i: any) { return !(a.indexOf(i) > -1); });
      };
    }

    // Get only unique (primitive types only)
    // Ref: https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
    if (!Array.prototype.unique) {
      Array.prototype.unique = function () {
        return [...new Set(this)];
      };
    }

    if (!String.prototype.toFirstUppercase) {
      String.prototype.toFirstUppercase = function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
      };
    }

    if (!String.prototype.toCPF) {
      String.prototype.toCPF = function () {
        return this
          .replace(/\./g, '')
          .replace(/\//g, '')
          .replace(/\-/g, '')
          .replace(/\D/g, '')
          .replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      };
    }

    if (!String.prototype.toCNPJ) {
      String.prototype.toCNPJ = function () {
        return this
          .replace(/\./g, '')
          .replace(/\//g, '')
          .replace(/\-/g, '')
          .replace(/\D/g, '')
          .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
      };
    }

    if (!String.prototype.toCEP) {
      String.prototype.toCEP = function () {
        return this
          .replace(/\-/g, '')
          .replace(/\D/g, '')
          .replace(/^(\d{5})(\d{3})/, "$1-$2");
      };
    }

    if (!String.prototype.toFone) {
      String.prototype.toFone = function () {

        if (![10, 11].includes(this.length))
          return this;

        let str = this
          .replace(/\./g, '')
          .replace(/\//g, '')
          .replace(/\-/g, '')
          .replace(/\(/g, '')
          .replace(/\)/g, '')
          .replace(/\D/g, '');

        if (this.length === 10) {
          str = str
            .replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
        }

        if (this.length === 11) {
          str = str
            .replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
        }

        return str;

      };
    }

    if (!String.prototype.toRemovePontuacao) {
      String.prototype.toRemovePontuacao = function () {
        return this
          .replace(/\./g, '')
          .replace(/\//g, '')
          .replace(/\-/g, '')
          .replace(/\(/g, '')
          .replace(/\)/g, '')
          .replace(/\D/g, '');
      };
    }

  }

}
